import { render, staticRenderFns } from "./cardPromocion1.vue?vue&type=template&id=6282ca26&scoped=true&"
import script from "./cardPromocion1.vue?vue&type=script&lang=js&"
export * from "./cardPromocion1.vue?vue&type=script&lang=js&"
import style0 from "./cardPromocion1.vue?vue&type=style&index=0&id=6282ca26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6282ca26",
  null
  
)

export default component.exports